import { observable, flow, toJS, action } from "mobx";
import _ from "lodash";
import { message, notification, Modal } from "antd";
import { RouterState } from "mobx-state-router";
import { showError } from "utils/utils";
import {
	getContentGroups,
	getAllProfilesWithCampaigns,
	getSiteInfos,
	registerHandler,
	getSiteSelections,
	downloadRankerXEmail,
	downloadEmailFromEmailList,
	testEmail,
	generateRandomInfo,
	delay
} from "services/api";
import { getPrivateNetworks } from "services/privatenetworks";
import { encrypt, getModulusFromString, getRandomInvisibleCharacter, getModulusString } from "common/abc";
import {
	createCampaign,
	addWizard,
	saveWizard,
	getWizard
} from "services/wizard";

import { getStrategy, getStrategies } from "services/strategies";
import { getCampaign } from "services/campaigns";

import graphlib from "graphlib";
import joint from "rappid";
import moment from "moment";
import LZString from "lz-string";
import Cookies from "common/cookies";

const pType = [
	"primaryPercentage",
	"secondaryPercentage",
	"brandedPercentage",	
	"genericPercentage",
	"nakedUrlPercentage"
];

const Messages = {
	failedToSaveWizard: "Failed to save the wizard. Unknown error",
	successfullySaveWizard: "Successfully saved the wizard"
};

const mycompress = "compressToEncodedURIComponent";

let pTypeMap = [];
for (let i = 0; i < pType.length; i++) {
	let type = pType[i];
	pTypeMap[type] = i;
}


function findDepth(g, rootNode) {
	let visited = {};
	let distance = {};
	let queue = [];
	let depth = 0;

	queue.push(rootNode);
	distance[rootNode] = 0;
	while (queue.length > 0) {
		var next = queue.shift();
		if (!visited[next]) {
			if (distance[next] > depth) depth = distance[next];
			visited[next] = true;
			_.each(g.successors(next), function(w) {
				distance[w] = distance[next] + 1;
				queue.push(w);
			});
		}
	}
	return {
		depth,
		distance
	};
}

class XWizardStore {
	rootStore;

	constructor(rootStore) {
		this.rootStore = rootStore;
		this.ui = this.getUI();
	}

	@observable
	wizard = {
		id: 0,
		name: "",
		saveWizard: false,
		campaignName: "",
		strategy: {},
		linksAndKeywords: [],
		content: [], //based on tier
		projects: [], //each project
		indexers: [],
		emailSource: "RANKERX",
		emailAccount: {},
		tierSiteSelection: [],
		// siteSelection: {
		// 	type: 3, //1: All Sites, 2: Custom Site Selection, 3: Manual
		// 	selectedSites: [],
		// 	siteSelectionId: 0
		// },
		depth: 0
	};

	@observable
	ui = {};

	@observable
	stateForm = {};

	@observable
	sites = [];

	@observable
	profiles = [];

	@observable
	strategies = [];

	@observable
	contentGroups = [];

	@observable
	customSiteSelections = [];

	@observable
	privateNetworks = [];

	projectGraph = null;
	distance = {};

	@observable
	strategy = {};

	tierSites = []; //array of array

	createProfileNameDataSource = changedProfileName => {
		let dataSourceSet = new Set();

		for (let i = 0; i < this.stateForm.projects.length; i++) {
			let project = this.stateForm.projects[i];
			if (project.profileName.value) {
				dataSourceSet.add(project.profileName.value);
			}
		}

		if (changedProfileName) {
			dataSourceSet.delete(changedProfileName);
		}

		let dataSource = [];

		if (changedProfileName) {
			dataSource.push(changedProfileName);
		}

		for (let item of dataSourceSet.entries()) {
			dataSource.push(item[1]);
		}

		return dataSource;
	};

	@action
	setActiveTabKey = activeTabKey => {
		this.ui.activeTabKey = activeTabKey;
	};

	changeSecondaryPercentage = (tier, value) => {
		var delta =
			parseInt(value) -
			this.stateForm.linksAndKeywords[tier].secondaryPercentage.value;
		var primaryPercentage = this.stateForm.linksAndKeywords[tier]
			.primaryPercentage.value;

		var genericPercentage = this.stateForm.linksAndKeywords[tier]
			.genericPercentage.value;

		var nakedUrlPercentage = this.stateForm.linksAndKeywords[tier]
			.nakedUrlPercentage.value;

		var delta2 = primaryPercentage - delta;

		if (delta2 >= 0) {
			primaryPercentage = delta2;
		} else {
			primaryPercentage = 0;
			var delta3 = genericPercentage + delta2;
			if (delta3 >= 0) {
				genericPercentage = delta3;
			} else {
				genericPercentage = 0;
				nakedUrlPercentage = nakedUrlPercentage + delta3;
			}
		}
		var secondaryPercentage = parseInt(value);

		this.stateForm.linksAndKeywords[
			tier
		].primaryPercentage.value = primaryPercentage;
		this.stateForm.linksAndKeywords[
			tier
		].secondaryPercentage.value = secondaryPercentage;
		this.stateForm.linksAndKeywords[
			tier
		].genericPercentage.value = genericPercentage;
		this.stateForm.linksAndKeywords[
			tier
		].nakedUrlPercentage.value = nakedUrlPercentage;
	};

	changeGenericPercentage = (tier, value) => {
		var delta =
			parseInt(value) -
			this.stateForm.linksAndKeywords[tier].genericPercentage.value;
		var primaryPercentage = this.stateForm.linksAndKeywords[tier]
			.primaryPercentage.value;
		var secondaryPercentage = this.stateForm.linksAndKeywords[tier]
			.secondaryPercentage.value;
		var nakedUrlPercentage = this.stateForm.linksAndKeywords[tier]
			.nakedUrlPercentage.value;

		var delta2 = primaryPercentage - delta;

		if (delta2 >= 0) {
			primaryPercentage = delta2;
		} else {
			primaryPercentage = 0;
			var delta3 = secondaryPercentage + delta2;
			if (delta3 >= 0) {
				secondaryPercentage = delta3;
			} else {
				secondaryPercentage = 0;
				nakedUrlPercentage = nakedUrlPercentage + delta3;
			}
		}
		var genericPercentage = parseInt(value);
		this.stateForm.linksAndKeywords[
			tier
		].primaryPercentage.value = primaryPercentage;
		this.stateForm.linksAndKeywords[
			tier
		].secondaryPercentage.value = secondaryPercentage;
		this.stateForm.linksAndKeywords[
			tier
		].genericPercentage.value = genericPercentage;
		this.stateForm.linksAndKeywords[
			tier
		].nakedUrlPercentage.value = nakedUrlPercentage;
	};

	changeNakedUrlPercentage = (tier, value) => {
		var delta =
			parseInt(value) -
			this.stateForm.linksAndKeywords[tier].nakedUrlPercentage.value;
		var primaryPercentage = this.stateForm.linksAndKeywords[tier]
			.primaryPercentage.value;
		var secondaryPercentage = this.stateForm.linksAndKeywords[tier]
			.secondaryPercentage.value;
		var genericPercentage = this.stateForm.linksAndKeywords[tier]
			.genericPercentage.value;

		var delta2 = primaryPercentage - delta;

		if (delta2 >= 0) {
			primaryPercentage = delta2;
		} else {
			primaryPercentage = 0;
			var delta3 = secondaryPercentage + delta2;
			if (delta3 >= 0) {
				secondaryPercentage = delta3;
			} else {
				secondaryPercentage = 0;
				genericPercentage = genericPercentage + delta3;
			}
		}
		var nakedUrlPercentage = parseInt(value);
		this.stateForm.linksAndKeywords[
			tier
		].primaryPercentage.value = primaryPercentage;
		this.stateForm.linksAndKeywords[
			tier
		].secondaryPercentage.value = secondaryPercentage;
		this.stateForm.linksAndKeywords[
			tier
		].genericPercentage.value = genericPercentage;
		this.stateForm.linksAndKeywords[
			tier
		].nakedUrlPercentage.value = nakedUrlPercentage;
	};

	changePercentage = (tier, linkSetId, index, value) => {
		let currentLinkSet = this.stateForm.linksAndKeywords[tier].linkSets[linkSetId];
		
		let currentPercentage = currentLinkSet[
			pType[index]
		].value;
		let delta = currentPercentage - value;

		let newValues = [];
		for (let i = 0; i < pType.length; i++) {
			if (i == index) {
				newValues[i] = value;
				continue;
			}
			newValues[i] = currentLinkSet[
				pType[i]
			].value;
		}

		for (let i = 0; i < pType.length; i++) {
			if (i != index) {
				let delta2 =
					currentLinkSet[pType[i]].value +
					delta;
				if (delta2 >= 0) {
					newValues[i] = delta2;
					break;
				} else {
					newValues[i] = 0;
					delta = delta2;
				}
			} else {
				newValues[i] = value;
			}
		}

		for (let i = 0; i < pType.length; i++) {
			currentLinkSet[pType[i]].value =
				newValues[i];
		}
	};

	mergeCustomizer = (objValue, srcValue, key, object, source, stack) => {	
		if (srcValue == undefined && !_.isArray(source)) {
			return null;
		}
		if (key === "value" && _.isArray(srcValue)) {
			return observable.array(srcValue);
		}
	};
	
	@action
	formChanged = fields => {
		// console.log("Form Changed", fields);		
		// let customizer = (objValue, srcValue, key, object, source, stack) => {
		// 	// console.log("Key is: " + key);
		// 	// console.log("Stack is: " + JSON.stringify(stack));
		// 	// console.log(srcValue);
		// 	// console.log(objValue);
		// 	if (srcValue == undefined && !_.isArray(source)) {
		// 		return null;
		// 	}
		// 	if (key === "value" && _.isArray(srcValue)) {
		// 		return observable.array(srcValue);
		// 	}
		// };

		if (fields.linksAndKeywords) {
			for (let i = 0; i < fields.linksAndKeywords.length; i++) {
				let linksAndKeywords = fields.linksAndKeywords[i];
				if (linksAndKeywords) {			
					if (linksAndKeywords.linkSets) {
						let linkSets = linksAndKeywords.linkSets;
						for (let j = 0; j < linkSets.length; j++) {
							let linkSet = linkSets[j];
							if (linkSet) {
								if (linkSet.primaryPercentage) {
									return;
								}
								if (linkSet.secondaryPercentage) {
									this.changePercentage(
										i,
										j,
										pTypeMap["secondaryPercentage"],
										linkSet.secondaryPercentage.value
									);
									return;
								}
								if (linkSet.brandedPercentage) {
									this.changePercentage(
										i,
										j,
										pTypeMap["brandedPercentage"],
										linkSet.brandedPercentage.value
									);
									return;
								}
								if (linkSet.genericPercentage) {
									this.changePercentage(
										i,
										j,
										pTypeMap["genericPercentage"],
										linkSet.genericPercentage.value
									);
									return;
								}
								if (linkSet.nakedUrlPercentage) {
									this.changePercentage(
										i,
										j,
										pTypeMap["nakedUrlPercentage"],
										linkSet.nakedUrlPercentage.value
									);
									return;
								}
							}
						}
					}	

					// if (linksAndKeywords.primaryPercentage) {
					// 	return;
					// }
					// if (linksAndKeywords.secondaryPercentage) {
					// 	this.changePercentage(
					// 		i,
					// 		pTypeMap["secondaryPercentage"],
					// 		linksAndKeywords.secondaryPercentage.value
					// 	);
					// 	return;
					// }
					// if (linksAndKeywords.brandedPercentage) {
					// 	this.changePercentage(
					// 		i,
					// 		pTypeMap["brandedPercentage"],
					// 		linksAndKeywords.brandedPercentage.value
					// 	);
					// 	return;
					// }
					// if (linksAndKeywords.genericPercentage) {
					// 	this.changePercentage(
					// 		i,
					// 		pTypeMap["genericPercentage"],
					// 		linksAndKeywords.genericPercentage.value
					// 	);
					// 	return;
					// }
					// if (linksAndKeywords.nakedUrlPercentage) {
					// 	this.changePercentage(
					// 		i,
					// 		pTypeMap["nakedUrlPercentage"],
					// 		linksAndKeywords.nakedUrlPercentage.value
					// 	);
					// 	return;
					// }
				}
			}
		}

		if (fields.projects) {
			// console.log("Project changed");
			let profileNameChanged = false;
			let changedProjectIndex = -1;
			for (let i = 0; i < fields.projects.length; i++) {
				let project = fields.projects[i];
				if (project) {
					changedProjectIndex = i;
					if (project.profileName) {
						profileNameChanged = true;
					}
					let currentProject = this.stateForm.projects[i];
					_.mergeWith(currentProject, project, this.mergeCustomizer);
				}
			}
			if (profileNameChanged) {
				let dataSourceSet = new Set();
				
				let changedProject = this.stateForm.projects[
					changedProjectIndex
				];

				for (let i = 0; i < this.stateForm.projects.length; i++) {
					if (i != changedProjectIndex) {
						let project = this.stateForm.projects[i];							
						if (changedProject.group != "" && changedProject.group == project.group) {							
							project.profileName.value = changedProject.profileName.value;
						}				
						if (project.profileName && project.profileName.value) {
							dataSourceSet.add(project.profileName.value);
						}
					}
				}

				if (
					changedProject.profileName &&
					changedProject.profileName.value
				) {
					dataSourceSet.delete(changedProject.profileName.value);
				}

				let dataSource = [];

				for (let item of dataSourceSet.entries()) {
					dataSource.push(item[1]);
				}

				if (
					changedProject.profileName &&
					changedProject.profileName.value
				) {
					dataSource.unshift(changedProject.profileName.value);
				}
				this.ui.newAccountProfileDataSource = observable.array(
					dataSource
				);
			} else {				
				let profileIdChanged = false;
				for (let i = 0; i < fields.projects.length; i++) {
					let project = fields.projects[i];
					if (project) {
						changedProjectIndex = i;
						if (project.profileId) {
							profileIdChanged = true;
						}
						let currentProject = this.stateForm.projects[i];
						_.mergeWith(currentProject, project, this.mergeCustomizer);
					}
				}
				if (profileIdChanged) {
					let changedProject = this.stateForm.projects[
						changedProjectIndex
					];					
					for (let i = 0; i < this.stateForm.projects.length; i++) {
						if (i != changedProjectIndex) {
							let project = this.stateForm.projects[i];							
							if (changedProject.group != "" && changedProject.group == project.group) {							
								project.profileId.value = changedProject.profileId.value;
							}
						}
					}
				} else {
					let createNewAccountChanged = false;

					for (let i = 0; i < fields.projects.length; i++) {
						let project = fields.projects[i];
						if (project) {
							changedProjectIndex = i;
							if (project.createNewAccount) {
								createNewAccountChanged = true;
							}
							let currentProject = this.stateForm.projects[i];
							_.mergeWith(currentProject, project, this.mergeCustomizer);
						}
					}

					if (createNewAccountChanged) {
						let changedProject = this.stateForm.projects[
							changedProjectIndex
						];					
						for (let i = 0; i < this.stateForm.projects.length; i++) {
							if (i != changedProjectIndex) {
								let project = this.stateForm.projects[i];							
								if (changedProject.group != "" && changedProject.group == project.group) {							
									project.createNewAccount.value = changedProject.createNewAccount.value;
								}
							}
						}
					}
				}
			}
			return;
		}
		_.mergeWith(this.stateForm, fields, this.mergeCustomizer);
	};

	createFormObject = project => {
		function customizer(value, key, object, stack) {
			if (!_.isObject(value) && key !== "value" && key != "group") {
				return {
					value: value
				};
			}
			if (_.isObject(value) && key == "startDate") {
				return {
					value: _.cloneDeep(value)
				};
			}

			if (_.isArray(value) && key == "indexers") {
				let result = [];
				for (let i = 0; i < value.length; i++) {
					result.push({
						value: _.cloneDeep(value[i])
					});
				}
				return result;
			}
			if (
				_.isArray(value) &&
				key != "content" &&
				key != "linksAndKeywords" &&
				key != "linkSets" &&
				key != "tierSiteSelection" &&
				key != "indexers" &&
				key != "useIndexers" &&
				key != "useSameAccounts" &&
				key != "projects"
			) {
				return _.cloneDeep(value);
			}
		}

		let newObj = _.cloneDeepWith(toJS(project), customizer);
		return newObj;
	};

	getUI = () => {
		let ui = observable.object({
			loading: true,
			creatingCampaign: false,
			savingWizard: false,
			newAccountProfileDataSource: [],
			downloadingRankerXEmail: false,
			downloadingEmailFromEmailList: false,
			generatingRandomInfo: false,
			testingEmail: false,
			activeTabKey: "Strategy"			
		});
		return ui;
	};

	@action
	addNewLinkSet = function() {
		let newLinkSet = {
			urls: "",
			primaryKeyword: "",
			secondaryKeyword: "",
			brandedKeyword: "",				
			genericKeyword: "",
			primaryPercentage: 100,
			secondaryPercentage: 0,
			brandedPercentage: 0,
			genericPercentage: 0,
			nakedUrlPercentage: 0
		};

		this.wizard.linksAndKeywords[0].linkSets.push(newLinkSet);
		let formObject = this.createFormObject(newLinkSet);
		this.stateForm.linksAndKeywords[0].linkSets.push(formObject);		
	}

	@action
	removeLinkSet = (linkSetId) => {		
		this.stateForm.linksAndKeywords[0].linkSets.splice(linkSetId, 1);
	}

	testEmail = flow(function*() {
		this.ui.testingEmail = true;
		const verificationInfo = this.getRawObjectFromFormObject(
			this.stateForm.emailAccount
		);
		const response = yield testEmail(verificationInfo);
		this.ui.testingEmail = false;

		if (!response) {
			message.error("Failed to login the email address. Unknown error");
			return;
		}

		if (response.error) {
			message.error(response.error.message);
			return;
		}

		message.success("Successfully logged in to the email address");
	});

	downloadRankerXEmail = flow(function*() {
		this.ui.downloadingRankerXEmail = true;
		yield delay(500);
		const response = yield downloadRankerXEmail();
		this.ui.downloadingRankerXEmail = false;
		if (response == null) {
			message.error(
				"Failed to download pre-created email address. Unexpected error",
				3
			);
			return;
		}

		if (response.error) {
			message.error(
				"Failed to download pre-created email address. " +
					response.error.message,
				3
			);
			return;
		}
		message.success("Successfully downloaded pre-created email address");

		this.stateForm.emailAccount = observable.object(
			this.createFormObject(response.emailSettings)
		);
	});

	downloadEmailFromEmailList = flow(function*() {
		this.ui.downloadingEmailFromEmailList = true;
		const response = yield downloadEmailFromEmailList();
		this.ui.downloadingEmailFromEmailList = false;
		if (response == null) {
			message.error(
				"Failed to download email from email list. Unexpected error",
				3
			);
			return;
		}

		if (response.error) {
			Modal.error({
				title: "Failed to download email from email list",
				content: response.error.message
				// placement: "topLeft"
			});
			// message.error(
			// 	"Failed to download email from email list. " + response.error.message,
			// 	3
			// );
			return;
		}
		message.success("Successfully downloaded email from email list");

		this.stateForm.emailAccount = observable.object(
			this.createFormObject(response.emailSettings)
		);

		// this.projectViewModel.verificationInfo = observable.object(
		// 	response.emailSettings
		// );
		// this.stateForm = observable.object(
		// 	this.createStateForm(this.projectViewModel)
		// );
	});

	clearData = () => {
		this.ui = this.getUI();

		this.wizard = observable.object({
			id: 0,
			name: "",
			saveWizard: false,
			campaignName: "",
			linksAndKeywords: [],
			content: [], //based on tier
			projects: [], //each project
			indexers: [],
			tierSiteSelection: [],
			// siteSelection: {
			// 	type: 3, //0: All Sites, 1: Custom Site Selection, 3: Manual
			// 	selectedSites: [],
			// 	siteSelectionId: 0
			// },
			sites: [],
			emailSource: "RANKERX",
			emailAccount: {
				emailAddress: "",
				emailLogin: "",
				emailPassword: "",
				emailServer: "",
				emailServerPort: 995,
				mailProtocol: null,
				SSL: true,
				checkSpamFolder: false,
				spamFolderName: ""
			},
			// verificationInfo: {
			// 	emailSource: "MANUAL",
			// 	emailAddress: "doan.chuvan@gmail.com",
			// 	emailAccount: {
			// 		emailAddress: "doan.chuvan1@gmail.com",
			// 		emailPassword: "nirvana1986",
			// 		emailServer: "pop3.gmail.com",
			// 		emailServerPort: 995,
			// 		mailProtocol: "POP3",
			// 		SSL: true
			// 	}
			// },
			useIndexers: [],
			useSameAccounts: [],
			startDate: moment
				.utc()
				.add(30, "minutes")
				.local(),
			nDay: 1,
			depth: 0
		});

		this.contentGroups = observable.array([]);
		this.profiles = observable.array([]);
		this.customSiteSelections = observable.array([]);
		this.strategies = observable.array([]);
		this.tierSites = observable.array([], { deep: false });
		this.projectGraph = null;
		this.distance = {};
	};

	getRawObjectFromFormObject = formObject => {
		function customizer(value) {
			if (_.isObject(value)) {
				if ("value" in value) {
					return value.value;
				}
			}
		}
		let rawJS = toJS(formObject);
		return _.cloneDeepWith(rawJS, customizer);
	};

	saveWizard = flow(function*() {
		let wizard = this.getRawObjectFromFormObject(this.stateForm);
		let tierSiteSelection = [];
		for (let tier = 0; tier < wizard.depth; tier++) {
			let sites = this.tierSites[tier];			
			let selectedSites = sites.filter(site => site.checked);
			selectedSites = selectedSites.map(selectedSite => {
				return {
					siteId: selectedSite.id.siteId,
					module: selectedSite.id.module
				};
			});
			let siteSelection = wizard.tierSiteSelection[tier];
			siteSelection = { ...siteSelection, selectedSites };

			tierSiteSelection[tier] = siteSelection;
		}
		
		this.ui.savingWizard = true;
		yield delay(300);

		let strategy = getModulusString(wizard.strategy.strategy);
		wizard.strategy.strategy = strategy;
		
		const wizardPayload = {
			id: wizard.id,
			name: wizard.name,
			campaignName: wizard.campaignName,
			strategy: wizard.strategy,
			tierSiteSelection: tierSiteSelection,
			linksAndKeywords: wizard.linksAndKeywords,
			content: wizard.content,
			blogName: wizard.blogName,
			blogTitle: wizard.blogTitle,
			username: wizard.username,
			password: wizard.password,
			firstName: wizard.firstName,
			lastName: wizard.lastName,
			emailSource: wizard.emailSource,
			emailAccount: wizard.emailAccount,
			useIndexers: wizard.useIndexers,
			useSameAccounts: wizard.useSameAccounts,
			indexers: wizard.indexers,
			projects: wizard.projects,
			startDate: wizard.startDate,
			nDay: wizard.nDay
		};

				
		let jsonData = JSON.stringify(wizardPayload);
		// let sessionId = Cookies.get("vertx-web.session");
		// let modulus = getModulusFromString(sessionId, jsonData.length);
		// console.log("Session id is: ", sessionId);
		// console.log("Data length is:" + jsonData.length);
		// console.log("Modulus is:", modulus);		
		// console.log("Character before that is: ", jsonData.charAt(modulus - 1));
		// let firstPart = jsonData.substring(0, modulus);
		// let lastPart = jsonData.substring(modulus, jsonData.length);		
		// let finalJsonData = firstPart + getRandomInvisibleCharacter() + lastPart;
		// console.log("Modified Data length is:" + finalJsonData.length);
		let compressedData = LZString.compressToEncodedURIComponent(
			jsonData
		);		

		// let base64FullMessage = encrypt(compressedData);
		let base64FullMessage = compressedData;

		let response = yield saveWizard(base64FullMessage);

		registerHandler([
			{		
				path: "xwizard",
				handler: function(err, msg) {
					if (err) {
						return;
					}					
				}
			}]);
		
		yield delay(1000);

		this.ui.savingWizard = false;

		if (response == null) {
			message.error(Messages.failedToSaveWizard, 5);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 5);
			return;
		}

		this.stateForm.id.value = response.id;

		message.success(Messages.successfullySaveWizard);
	});

	createCampaign = flow(function*(saveWizard) {
		let wizard = this.getRawObjectFromFormObject(this.stateForm);

		let tierSiteSelection = [];
		for (let tier = 0; tier < wizard.depth; tier++) {
			let sites = this.tierSites[tier];			
			let selectedSites = sites.filter(site => site.checked);
			selectedSites = selectedSites.map(selectedSite => {
				return {
					siteId: selectedSite.id.siteId,
					module: selectedSite.id.module
				};
			});
			let siteSelection = wizard.tierSiteSelection[tier];
			siteSelection = { ...siteSelection, selectedSites };

			tierSiteSelection[tier] = siteSelection;
		} 

		this.ui.creatingCampaign = true;

		let strategy = getModulusString(wizard.strategy.strategy);
		wizard.strategy.strategy = strategy;

		yield delay(300);
		const wizardPayload = {
			id: wizard.id,
			name: wizard.name,
			campaignName: wizard.campaignName,
			strategy: wizard.strategy,
			tierSiteSelection: tierSiteSelection,
			linksAndKeywords: wizard.linksAndKeywords,
			content: wizard.content,
			blogName: wizard.blogName,
			blogTitle: wizard.blogTitle,
			username: wizard.username,
			password: wizard.password,
			firstName: wizard.firstName,
			lastName: wizard.lastName,
			emailSource: wizard.emailSource,
			emailAccount: wizard.emailAccount,
			useIndexers: wizard.useIndexers,
			useSameAccounts: wizard.useSameAccounts,
			indexers: wizard.indexers,
			projects: wizard.projects,
			startDate: wizard.startDate,
			nDay: wizard.nDay
		};

		let compressedData = LZString[mycompress](
			JSON.stringify({
				saveWizard: saveWizard == true || wizard.saveWizard,
				wizard: wizardPayload
			})
		);

		// let base64FullMessage = encrypt(compressedData);
		let base64FullMessage = compressedData;

		let response = yield createCampaign(base64FullMessage);

		registerHandler([
			{		
				path: "xwizard",
				handler: function(err, msg) {
					if (err) {
						return;
					}					
				}
			}]);
		
		yield delay(2000);

		this.ui.creatingCampaign = false;

		if (response == null) {
			message.error("Failed to create the campaign. Unknown error", 5);
			return;
		}

		if (response.error) {
			if (!_.isArray(response.error)) {
				message.error(response.error.message, 5);
				return;
			} else {
				showError(response.error);
				return;
			}			
		}

		const routerStore = this.rootStore.routerStore;
		const campaignRoute = new RouterState("campaign", {
			id: response.campaignId
		});
		routerStore.goTo(campaignRoute);
		// message.success("Successfully saved the wizard");
	});

	@action
	copyGeneralSettings = (destTier, srcTier) => {
		if (destTier == srcTier) {
			return;
		}
		// console.log("Copying general settings");

		// console.log(srcTier);

		let srcGeneralSettings = this.stateForm.linksAndKeywords[srcTier];
		let destGeneralSettings = this.stateForm.linksAndKeywords[destTier];
		destGeneralSettings.linkSets[0].primaryKeyword = _.cloneDeep(
			srcGeneralSettings.linkSets[0].primaryKeyword
		);
		destGeneralSettings.linkSets[0].secondaryKeyword = _.cloneDeep(
			srcGeneralSettings.linkSets[0].secondaryKeyword
		);
		destGeneralSettings.linkSets[0].brandedKeyword = _.cloneDeep(
			srcGeneralSettings.linkSets[0].brandedKeyword
		);
		destGeneralSettings.linkSets[0].genericKeyword = _.cloneDeep(
			srcGeneralSettings.linkSets[0].genericKeyword
		);

		destGeneralSettings.linkSets[0].primaryPercentage = _.cloneDeep(
			srcGeneralSettings.linkSets[0].primaryPercentage
		);
		destGeneralSettings.linkSets[0].secondaryPercentage = _.cloneDeep(
			srcGeneralSettings.linkSets[0].secondaryPercentage
		);
		destGeneralSettings.linkSets[0].brandedPercentage = _.cloneDeep(
			srcGeneralSettings.linkSets[0].brandedPercentage
		);
		destGeneralSettings.linkSets[0].genericPercentage = _.cloneDeep(
			srcGeneralSettings.linkSets[0].genericPercentage
		);
		destGeneralSettings.linkSets[0].nakedUrlPercentage = _.cloneDeep(
			srcGeneralSettings.linkSets[0].nakedUrlPercentage
		);
		destGeneralSettings.linkSets[0].tags = _.cloneDeep(
			srcGeneralSettings.linkSets[0].tags
		);
		destGeneralSettings.linkPosition = _.cloneDeep(
			srcGeneralSettings.linkPosition
		);
	};

	@action
	addProfile = profile => {
		this.profiles.push({
			id: `${profile.id}`,
			pId: `c${profile.campaignId}`,
			value: `${profile.id}`,
			key: `${profile.id}`,
			title: profile.name
		});
	};

	@action
	addContentGroup = contentGroup => {
		this.contentGroups.push(contentGroup);
	};

	//Init the profiles array for accounts tab
	initProfiles = (profiles, campaigns) => {
		let profileFlatData = [];
		let campaignHasProfile = {};
		let campaignMap = {};

		for (var i = 0; i < campaigns.length; i++) {
			let campaign = campaigns[i];
			campaignMap[campaign.id] = campaign;
		}

		for (var i = 0; i < profiles.length; i++) {
			let profile = profiles[i];
			let campaign = campaignMap[profile.campaignId];
			if (campaign != null) {
				profileFlatData.push({
					id: `${profile.id}`,
					pId: `c${profile.campaignId}`,
					// value: `${campaign.name} ${profile.name} ${profile.id}`,
					value: `${profile.id}`,
					textValue: `${campaign.name} ${profile.name} ${profile.id}`,
					key: `${profile.id}`,
					title: `${profile.id} - ${profile.name}`
				});
				campaignHasProfile[`c${profile.campaignId}`] = true;
			}
		}

		for (var i = 0; i < campaigns.length; i++) {
			let campaign = campaigns[i];
			if (campaignHasProfile[`c${campaign.id}`] != undefined) {
				let title = campaign.name;
				if (!title.startsWith("Campaign")) {
					title = "Campaign: " + title;
				}
				profileFlatData.push({
					id: `c${campaign.id}`,
					value: `c${campaign.id}`,
					textValue: `${campaign.name}`,
					key: `c${campaign.id}`,
					title: title,
					selectable: false
				});
			}
		}
		return observable.array(profileFlatData);
	};

	initCustomSiteSelections = siteSelections => {
		let customSiteSelections = [];
		for (var i = 0; i < siteSelections.length; i++) {
			let siteSelection = siteSelections[i];
			customSiteSelections.push({
				id: siteSelection.id,
				name: siteSelection.name
			});
		}
		return observable.array(customSiteSelections);
	};

	//Load wizard
	initWizard = flow(function*(wizardId) {
		this.clearData();

		const [
			wizardResponse,
			strategiesResponse,
			contentGroupsResponse,
			profilesAndCampaignsResponse,
			siteInfosResponse,
			siteSelectionsResponse,
			privateNetworksResponse
		] = yield Promise.all(
			yield [
				getWizard(wizardId),
				getStrategies(),
				getContentGroups(),
				getAllProfilesWithCampaigns(),
				getSiteInfos(),
				getSiteSelections(),
				getPrivateNetworks()
			]
		);
		// const wizardResponse = yield getWizard(wizardId);

		if (!wizardResponse) {
			message.error("Failed to get the wizard. Unknown error", 5);
			return;
		}

		if (wizardResponse.error) {
			message.error(wizardResponse.error.message, 5);
			return;
		}

		// const strategiesResponse = yield getStrategies();
		if (strategiesResponse == null) {
			message.error(
				"Failed to init the wizard. Could not load the diagram"
			);
			return;
		}

		if (strategiesResponse.error) {
			message.error(strategiesResponse.error);
			return;
		}
		const strategies = strategiesResponse.strategies;
		this.strategies = observable.array(strategies);

		// const contentGroupsResponse = yield getContentGroups();

		if (contentGroupsResponse == null) {
			message.error("Failed to init the wizard");
			return;
		}

		// const profilesAndCampaignsResponse = yield getAllProfilesWithCampaigns();

		if (profilesAndCampaignsResponse == null) {
			message.error("Failed to init the wizard");
			return;
		}

		// const siteInfosResponse = yield getSiteInfos();
		if (siteInfosResponse == null) {
			message.error("Failed to init the wizard");
			return;
		}

		// const siteSelectionsResponse = yield getSiteSelections();
		if (siteSelectionsResponse == null) {
			message.error("Failed to init wizard");
			return;
		}

		// const privateNetworksResponse = yield getPrivateNetworks();
		if (privateNetworksResponse == null) {
			message.error("Failed ot init wizards");
		}

		this.privateNetworks = observable.array(
			privateNetworksResponse.objects
		);

		this.customSiteSelections = this.initCustomSiteSelections(
			siteSelectionsResponse.site_selections
		);

		for (var i = 0; i < contentGroupsResponse.content_groups.length; i++) {
			let contentGroup = contentGroupsResponse.content_groups[i];
			this.contentGroups.push(contentGroup);
		}

		this.profiles = this.initProfiles(
			profilesAndCampaignsResponse.profiles,
			profilesAndCampaignsResponse.campaigns
		);

		let wizard = wizardResponse.wizard;

		wizard.startDate = wizard.startDate
			? moment.unix(wizard.startDate / 1000).local()
			: null;

		// wizard.startDate = moment
		// 	.utc()
		// 	.add(30, "minutes")
		// 	.local();

		// wizard.startDate = null;

		this.wizard = observable.object(wizard);

		const graph = new joint.dia.Graph();

		// const strategy = (this.strategy = strategyResponse.strategy);
		this.strategy = this.wizard.strategy;
		graph.fromJSON(JSON.parse(this.strategy.strategy));

		const elements = graph.getElements();

		for (let i = 0; i < elements.length; i++) {
			const element = elements[i];
			const profileName = element.attr("custom/profileName");
			element.attr("bodyText/text", profileName);
			const projectName = element.attr("custom/projectName");
			element.attr("headerText/text", projectName);
		}

		this.strategy.strategy = JSON.stringify(graph.toJSON());

		const g = (this.projectGraph = graph.toGraphLib({
			setNodeLabel: function(cell) {
				return {
					module: cell.get("type"),
					name: cell.attr("headerText/text"),
					profileName: cell.attr("custom/profileName")
				};
			}
		}));

		// let g = (this.projectGraph = graphlib.json.read(graphObj));
		let nodes = g.nodes();
		let moneySite = null;
		for (var i = 0; i < nodes.length; i++) {
			if (g.node(nodes[i]).module == "rankerx.MoneySite") {
				moneySite = nodes[i];
			}
		}

		let visitResult = findDepth(g, moneySite);
		this.wizard.depth = visitResult.depth;
		this.distance = visitResult.distance;

		let tierAvailableModules = [];

		for (let i = 0; i < wizard.projects.length; i++) {
			let project = wizard.projects[i];
			let availableModules = tierAvailableModules[project.tier - 1];
			if (!availableModules) {
				availableModules = new Set();					
				tierAvailableModules[project.tier - 1] = availableModules;
			}
			if (project.premium === true) {
				availableModules.add(project.module + "Premium");
			} else {
				availableModules.add(project.module);
			}			
		}

		for (let tier = 0; tier < this.wizard.depth; tier++) {			
			let availableModules = tierAvailableModules[tier];

			let sites = _.cloneDeep(
				siteInfosResponse.sites.filter(siteInfo => {
					let module = siteInfo.id.module;
					let platform = siteInfo.platform;
					if (platform == "Premium" || platform.indexOf("Edu/Gov") != -1) {
						return availableModules.has(module + "Premium") || availableModules.has(module);
					} else {
						return availableModules.has(module);
					}					
				})
			);

			let selectedSiteSet = new Set();
			let siteSelection = wizard.tierSiteSelection[tier];

			for (let i = 0; i < siteSelection.selectedSites.length; i++) {
				let selectedSite = siteSelection.selectedSites[i];
				selectedSiteSet.add(
					selectedSite.module + "_" + selectedSite.siteId
				);
			}

			for (let i = 0; i < sites.length; i++) {
				let site = sites[i];
				if (selectedSiteSet.has(site.id.module + "_" + site.id.siteId)) {
					site.checked = true;
				}
			}

			this.tierSites[tier] = observable.array(sites, { deep: false});
		}

		// let sites = _.cloneDeep(
		// 	siteInfosResponse.sites.filter(siteInfo => {
		// 		let module = siteInfo.id.module;
		// 		return availableModules.has(module);
		// 	})
		// );

		// let selectedSiteSet = new Set();
		// for (let i = 0; i < wizard.siteSelection.selectedSites.length; i++) {
		// 	let selectedSite = wizard.siteSelection.selectedSites[i];
		// 	selectedSiteSet.add(
		// 		selectedSite.module + "_" + selectedSite.siteId
		// 	);
		// }

		// for (let i = 0; i < sites.length; i++) {
		// 	let site = sites[i];
		// 	if (selectedSiteSet.has(site.id.module + "_" + site.id.siteId)) {
		// 		site.checked = true;
		// 	}
		// }

		// this.sites = observable.array(sites, { deep: false });

		this.wizard.saveWizard = false;

		this.stateForm = observable.object(this.createFormObject(this.wizard));

		this.ui.newAccountProfileDataSource = this.createProfileNameDataSource();
		this.ui.loading = false;

		registerHandler([
			{		
				path: "xwizard",
				handler: function(err, msg) {
					if (err) {
						return;
					}					
				}
			},
			{
				path: "content_groups",
				handler: function(err, msg) {
					if (err) {
						// console.log(err);
						return;
					}

					let obj = JSON.parse(msg.body);
					if (obj.action == "newContentGroup") {
						let contentGroup = obj.contentGroup;
						this.addContentGroup(contentGroup);
					}
				}.bind(this)
			},
			{
				path: "campaigns",
				handler: function(err, msg) {
					if (err) {
						return;
					}
					let obj = JSON.parse(msg.body);
					if (obj.action == "newProfile") {
						let newProfile = obj.profile;
						this.addProfile(newProfile);
					}
				}.bind(this)
			}
		]);
	});

	duplicateCampaign = flow(function*(campaignId, newCampaignName, useSameAccounts) {
		this.clearData();
		const [
			campaignResponse,
			strategiesResponse,
			contentGroupsResponse,
			profilesAndCampaignsResponse,
			siteInfosResponse,
			siteSelectionsResponse,
			privateNetworksResponse
		] = yield Promise.all(
			yield [
				getCampaign(campaignId),
				getStrategies(),
				getContentGroups(),
				getAllProfilesWithCampaigns(),
				getSiteInfos(),
				getSiteSelections(),
				getPrivateNetworks()
			]
		);

		// let campaignResponse = yield getCampaign(campaignId);

		if (campaignResponse == null) {
			message.error("Failed to load the campaign to duplicate", 5);
			return;
		}

		if (campaignResponse.error != null) {
			message.error(campaignResponse.error.message, 5);
			return;
		}

		let campaign = campaignResponse.campaign;
		if (campaign.creatingType != "XWizard") {
			message.error("This campaign wasn't created using XWizard", 5);
			return;
		}

		// const strategiesResponse = yield getStrategies();
		if (strategiesResponse == null) {
			message.error(
				"Failed to init the wizard. Could not load the diagram"
			);
			return;
		}

		if (strategiesResponse.error) {
			message.error(strategiesResponse.error);
			return;
		}
		const strategies = strategiesResponse.strategies;
		this.strategies = observable.array(strategies);

		// const contentGroupsResponse = yield getContentGroups();

		if (contentGroupsResponse == null) {
			message.error("Failed to init the wizard");
			return;
		}

		// const profilesAndCampaignsResponse = yield getAllProfilesWithCampaigns();

		if (profilesAndCampaignsResponse == null) {
			message.error("Failed to init the wizard");
			return;
		}

		// const siteInfosResponse = yield getSiteInfos();
		if (siteInfosResponse == null) {
			message.error("Failed to init the wizard");
			return;
		}

		// const siteSelectionsResponse = yield getSiteSelections();
		if (siteSelectionsResponse == null) {
			message.error("Failed to init wizard");
			return;
		}

		// const privateNetworksResponse = yield getPrivateNetworks();
		if (privateNetworksResponse == null) {
			message.error("Failed ot init wizards");
		}

		this.privateNetworks = observable.array(
			privateNetworksResponse.objects
		);

		this.customSiteSelections = this.initCustomSiteSelections(
			siteSelectionsResponse.site_selections
		);

		for (var i = 0; i < contentGroupsResponse.content_groups.length; i++) {
			let contentGroup = contentGroupsResponse.content_groups[i];
			this.contentGroups.push(contentGroup);
		}

		this.profiles = this.initProfiles(
			profilesAndCampaignsResponse.profiles,
			profilesAndCampaignsResponse.campaigns
		);

		let wizardString = campaign.wizardString;
		let wizard = JSON.parse(
			LZString.decompressFromEncodedURIComponent(wizardString)
		);

		// wizard.startDate = moment.utc(wizard.startDate).local();
		// wizard.startDate = moment
		// 	.utc()
		// 	.add(30, "minutes")
		// 	.local();
		wizard.startDate = null;

		wizard.campaignName = newCampaignName;

		this.wizard = observable.object(wizard);

		const graph = new joint.dia.Graph();

		// const strategy = (this.strategy = strategyResponse.strategy);
		this.strategy = this.wizard.strategy;
		graph.fromJSON(JSON.parse(this.strategy.strategy));

		const elements = graph.getElements();

		for (let i = 0; i < elements.length; i++) {
			const element = elements[i];
			const profileName = element.attr("custom/profileName");
			element.attr("bodyText/text", profileName);
			const projectName = element.attr("custom/projectName");
			element.attr("headerText/text", projectName);
		}

		this.strategy.strategy = JSON.stringify(graph.toJSON());

		const g = (this.projectGraph = graph.toGraphLib({
			setNodeLabel: function(cell) {
				return {
					module: cell.get("type"),
					name: cell.attr("headerText/text"),
					profileName: cell.attr("custom/profileName")
				};
			}
		}));

		// let g = (this.projectGraph = graphlib.json.read(graphObj));
		let nodes = g.nodes();
		let moneySite = null;
		for (var i = 0; i < nodes.length; i++) {
			if (g.node(nodes[i]).module == "rankerx.MoneySite") {
				moneySite = nodes[i];
			}
		}

		let visitResult = findDepth(g, moneySite);
		this.wizard.depth = visitResult.depth;
		this.distance = visitResult.distance;

		let tierAvailableModules = [];

		for (let i = 0; i < wizard.projects.length; i++) {
			let project = wizard.projects[i];
			let availableModules = tierAvailableModules[project.tier - 1];
			if (!availableModules) {
				availableModules = new Set();					
				tierAvailableModules[project.tier - 1] = availableModules;
			}
			if (project.premium === true) {
				availableModules.add(project.module + "Premium");
			} else {
				availableModules.add(project.module);
			}			
		}		

		for (let tier = 0; tier < this.wizard.depth; tier++) {			
			let availableModules = tierAvailableModules[tier];

			let sites = _.cloneDeep(
				siteInfosResponse.sites.filter(siteInfo => {
					let module = siteInfo.id.module;
					let platform = siteInfo.platform;
					if (platform == "Premium" || platform.indexOf("Edu/Gov") != -1) {
						return availableModules.has(module + "Premium") || availableModules.has(module);
					} else {
						return availableModules.has(module);
					}					
				})
			);

			let selectedSiteSet = new Set();
			let siteSelection = wizard.tierSiteSelection[tier];

			for (let i = 0; i < siteSelection.selectedSites.length; i++) {
				let selectedSite = siteSelection.selectedSites[i];
				selectedSiteSet.add(
					selectedSite.module + "_" + selectedSite.siteId
				);
			}

			for (let i = 0; i < sites.length; i++) {
				let site = sites[i];
				if (selectedSiteSet.has(site.id.module + "_" + site.id.siteId)) {
					site.checked = true;
				}
			}

			this.tierSites[tier] = observable.array(sites, { deep: false});
		}		

		for (let i = 0; i < this.wizard.projects.length; i++) {
			let project = this.wizard.projects[i];
			if (!useSameAccounts) {
				//If create new accounts and this is not a private network project
				if (project.module && project.module.toLowerCase().indexOf("private") == -1) {
					project.createNewAccount = true;
				}				
			}
		}		

		this.wizard.saveWizard = false;

		this.stateForm = observable.object(this.createFormObject(this.wizard));

		this.ui.newAccountProfileDataSource = this.createProfileNameDataSource();
		this.ui.loading = false;

		registerHandler([
			{
				path: "content_groups",
				handler: function(err, msg) {
					if (err) {
						// console.log(err);
						return;
					}

					let obj = JSON.parse(msg.body);
					if (obj.action == "newContentGroup") {
						let contentGroup = obj.contentGroup;
						this.addContentGroup(contentGroup);
					}
				}.bind(this)
			},
			{
				path: "campaigns",
				handler: function(err, msg) {
					if (err) {
						return;
					}
					let obj = JSON.parse(msg.body);
					if (obj.action == "newProfile") {
						let newProfile = obj.profile;
						this.addProfile(newProfile);
					}
				}.bind(this)
			}
		]);
	});

	initCampaign = flow(function*({strategyId, campaignName, wizardName, wizardId}) {
		// let {strategyId, campaignName, wizardName, wizardId} = opts;
		this.clearData();
		this.wizard.id = wizardId;		
		const [
			strategiesResponse,
			contentGroupsResponse,
			profilesAndCampaignsResponse,
			siteInfosResponse,
			siteSelectionsResponse,
			privateNetworksResponse
		] = yield Promise.all(
			yield [
				getStrategies(),
				getContentGroups(),
				getAllProfilesWithCampaigns(),
				getSiteInfos(),
				getSiteSelections(),
				getPrivateNetworks()
			]
		);

		// const strategiesResponse = yield getStrategies();
		if (strategiesResponse == null) {
			message.error(
				"Failed to init the wizard. Could not load the diagram"
			);
			return;
		}

		if (strategiesResponse.error) {
			message.error(strategiesResponse.error);
			return;
		}
		const strategies = strategiesResponse.strategies;
		this.strategies = observable.array(strategies);
		const strategy = strategies.find(strategy => {
			return strategy.id == strategyId;
		});

		if (!strategy) {
			message.error(
				"Failed to init the wizard. Could not find the diagram"
			);
			return;
		}

		// const contentGroupsResponse = yield getContentGroups();

		if (contentGroupsResponse == null) {
			message.error("Failed to init the wizard");
			return;
		}

		// const profilesAndCampaignsResponse = yield getAllProfilesWithCampaigns();

		if (profilesAndCampaignsResponse == null) {
			message.error("Failed to init the wizard");
			return;
		}

		// const siteInfosResponse = yield getSiteInfos();
		if (siteInfosResponse == null) {
			message.error("Failed to init the wizard");
			return;
		}

		// const siteSelectionsResponse = yield getSiteSelections();
		if (siteSelectionsResponse == null) {
			message.error("Failed to init wizard");
			return;
		}

		// const privateNetworksResponse = yield getPrivateNetworks();
		if (privateNetworksResponse == null) {
			message.error("Failed ot init wizards");
		}

		this.privateNetworks = observable.array(
			privateNetworksResponse.objects
		);

		this.customSiteSelections = this.initCustomSiteSelections(
			siteSelectionsResponse.site_selections
		);

		for (var i = 0; i < contentGroupsResponse.content_groups.length; i++) {
			let contentGroup = contentGroupsResponse.content_groups[i];
			this.contentGroups.push(contentGroup);
		}

		this.profiles = this.initProfiles(
			profilesAndCampaignsResponse.profiles,
			profilesAndCampaignsResponse.campaigns
		);

		const graph = new joint.dia.Graph();

		// const strategy = (this.strategy = strategyResponse.strategy);
		this.strategy = observable.object(strategy);
		this.wizard.strategy = this.strategy;

		graph.fromJSON(JSON.parse(strategy.strategy));

		const elements = graph.getElements();

		for (let i = 0; i < elements.length; i++) {
			const element = elements[i];
			const profileName = element.attr("custom/profileName");
			element.attr("bodyText/text", profileName);
			const projectName = element.attr("custom/projectName");
			element.attr("headerText/text", projectName);
		}

		this.strategy.strategy = JSON.stringify(graph.toJSON());

		const g = (this.projectGraph = graph.toGraphLib({
			setNodeLabel: function(cell) {
				return {
					module: cell.get("type"),
					name: cell.attr("headerText/text"),
					profileName: cell.attr("custom/profileName")
				};
			}
		}));

		// let g = (this.projectGraph = graphlib.json.read(graphObj));
		let nodes = g.nodes();
		let moneySite = null;
		for (var i = 0; i < nodes.length; i++) {
			if (g.node(nodes[i]).module == "rankerx.MoneySite") {
				moneySite = nodes[i];
			}
		}

		let visitResult = findDepth(g, moneySite);
		this.wizard.depth = visitResult.depth;
		this.distance = visitResult.distance;

		// console.log("Wizard depth is", this.wizard.depth);

		this.tierSites = [];

		let tierAvailableModules = [];

		let tmpProjects = [];
		for (var i = 0; i < nodes.length; i++) {
			let nodeId = nodes[i];
			let nodeValue = g.node(nodeId);
			let isPrivateProject =
				nodeValue.module.indexOf("rankerx.Private") != -1;
			if (nodeValue.module != "rankerx.MoneySite") {
				let availableModules = tierAvailableModules[this.distance[nodeId] - 1];
				if (!availableModules) {					
					availableModules = new Set();					
					tierAvailableModules[this.distance[nodeId] - 1] = availableModules;
				}

				availableModules.add(
					nodeValue.module
						.replace("rankerx.", "")
						// .replace("Premium", "")
				);
				let inEdges = g.inEdges(nodeId);
				let source = null;
				if (inEdges.length > 0) {
					let edge = inEdges[0];
					source = edge["v"];
				}
				let project = {
					id: nodeId,
					parentId: source,
					name: nodeValue.name,
					module: nodeValue.module
						.replace("rankerx.", "")
						.replace("Premium", ""),
					premium: nodeValue.module.indexOf("Premium") != -1,
					createNewAccount: isPrivateProject ? false : true,
					numberOfPosts: 0,
					// profileName: nodeValue.profileName,	
					profileName: "",				
					group: nodeValue.profileName,
					//TODO: profileId: 0,
					profileId: null,
					tier: this.distance[nodeId]
				};
				tmpProjects.push(project);				
			}
		}

		// tmpProjects = _.shuffle(tmpProjects);
		for (let i = 0; i < tmpProjects.length; i++) {
			this.wizard.projects.push(tmpProjects[i]);
		}		

		for (let tier = 0; tier < this.wizard.depth; tier++) {			
			let availableModules = tierAvailableModules[tier];

			let sites = _.cloneDeep(
				siteInfosResponse.sites.filter(siteInfo => {
					let module = siteInfo.id.module;
					let platform = siteInfo.platform;
					if (platform == "Premium" || platform.indexOf("Edu/Gov") != -1) {
						return availableModules.has(module + "Premium") || availableModules.has(module);
					} else {
						return availableModules.has(module);
					}					
				})
			);

			for (let i = 0; i < sites.length; i++) {
				let site = sites[i];
				site.checked = true;
			}

			this.tierSites[tier] = observable.array(sites, { deep: false });	

			this.wizard.tierSiteSelection[tier] = observable.object({
				type: 1, //1: All Sites, 2: Custom Site Selection, 3: Manual
				selectedSites: [],
				//TODO: siteSelectionId: 0,
				siteSelectionId: null			
			});
		}

		for (let i = 0; i < this.wizard.depth; i++) {
			this.wizard.linksAndKeywords.push({
				linkSets: [{
					urls: "",
					primaryKeyword: "",
					secondaryKeyword: "",
					brandedKeyword: "",				
					genericKeyword: "",
					primaryPercentage: 100,
					secondaryPercentage: 0,
					brandedPercentage: 0,
					genericPercentage: 0,
					nakedUrlPercentage: 0,					
				}],				
				minLinks: 1,
				maxLinks: 3,
				linkPosition: "ReplaceKeyword"
			});
		}

		for (let i = 0; i < this.wizard.depth; i++) {
			this.wizard.content.push({
				insertImages: false,
				searchForImages: false,
				imagePosition: "Random",
				keywordsForImage: "",
				imagesToInsert: "",
				minImage: 1,
				maxImage: 1,

				insertVideos: false,
				searchForVideos: false,
				videoPosition: "Random",
				keywordsForVideo: "",
				videosToInsert: "",
				minVideo: 1,
				maxVideo: 1
			});
		}

		for (let i = 0; i < this.wizard.depth; i++) {
			this.wizard.indexers.push([]);
			this.wizard.useIndexers.push(true);
			this.wizard.useSameAccounts.push(false);
		}

		wizardName ? (this.wizard.name = wizardName) : "";
		this.wizard.saveWizard = false;
		campaignName ? (this.wizard.campaignName = campaignName) : "";
		this.wizard.blogTitle = "";
		this.wizard.blogName = "";
		this.wizard.firstName = "";
		this.wizard.lastName = "";
		this.wizard.username = "";
		this.wizard.password = "";
		this.wizard.startDate = null;

		this.stateForm = observable.object(this.createFormObject(this.wizard));

		this.ui.newAccountProfileDataSource = this.createProfileNameDataSource();
		this.ui.loading = false;

		registerHandler([
			{
				path: "content_groups",
				handler: function(err, msg) {
					if (err) {
						// console.log(err);
						return;
					}

					let obj = JSON.parse(msg.body);
					if (obj.action == "newContentGroup") {
						let contentGroup = obj.contentGroup;
						this.addContentGroup(contentGroup);
					}
				}.bind(this)
			},
			{
				path: "campaigns",
				handler: function(err, msg) {
					if (err) {
						return;
					}
					let obj = JSON.parse(msg.body);
					if (obj.action == "newProfile") {
						let newProfile = obj.profile;
						this.addProfile(newProfile);
					}
				}.bind(this)
			}
		]);
	});

	generateRandomInfo = flow(function*() {
		this.ui.generatingRandomInfo = true;
		let response = yield generateRandomInfo();
		yield delay(500);

		this.ui.generatingRandomInfo = false;

		if (response == null) {
			message.error("Failed to generate random info.")
			return;
		}
		if (response.error) {
			message.error(response.error.message, 5);
			return;
		}

		let randomInfo = this.createFormObject(response);
		this.formChanged(randomInfo);
	});


	fetchWizard = flow(function*() {
		this.stateForm = observable.object(this.createFormObject(this.wizard));
		let g = new graphlib.Graph({
			directed: true,
			multigraph: false,
			compound: false
		});

		g.setNode("ms", { name: "Money Site" });
		g.setNode("p1", { name: "Project 1" });
		g.setNode("p2", { name: "Project 2" });
		g.setEdge("ms", "p1");
		g.setEdge("p1", "p2");
		g.setEdge("p2", "ms");
		if (graphlib.alg.isAcyclic(g)) {
			// console.log("Acyclic");
		} else {
			// console.log("Cyclic");
		}
	});
}

export default XWizardStore;

// const graphObj = {
// 	options: { directed: true, multigraph: false, compound: false },
// 	nodes: [
// 		{
// 			v: "90ad0d12-b105-4a72-bc1d-360fe5f5a973",
// 			value: {
// 				module: "rankerx.MoneySite",
// 				createNewAccount: true,
// 				profileName: null,
// 				profileId: 0
// 			}
// 		},
// 		{
// 			v: "97357d8d-615d-4069-b022-08841cdee0e8",
// 			value: {
// 				module: "rankerx.SocialNetwork",
// 				createNewAccount: false,
// 				profileId: 0
// 			}
// 		},
// 		{
// 			v: "b1698117-c6b5-490f-ada2-b003f1dd08e8",
// 			value: {
// 				module: "rankerx.WebProfile",
// 				createNewAccount: true,
// 				profileId: 0
// 			}
// 		},
// 		{
// 			v: "fef1a01f-d370-4586-9181-a7386b02b7db",
// 			value: {
// 				module: "rankerx.WebProfile",
// 				createNewAccount: true,
// 				profileId: 0
// 			}
// 		},
// 		{
// 			v: "9ef4022f-a46b-4be7-aafd-aaccaa52ecc9",
// 			value: {
// 				module: "rankerx.Bookmarking",
// 				createNewAccount: true,
// 				profileId: 0
// 			}
// 		},
// 		{
// 			v: "e235bd1d-bec9-4ce7-99e8-88dd35292604",
// 			value: {
// 				module: "rankerx.WebProfile",
// 				createNewAccount: true,
// 				profileId: 0
// 			}
// 		}
// 	],
// 	edges: [
// 		{
// 			v: "90ad0d12-b105-4a72-bc1d-360fe5f5a973",
// 			w: "97357d8d-615d-4069-b022-08841cdee0e8"
// 		},
// 		{
// 			v: "90ad0d12-b105-4a72-bc1d-360fe5f5a973",
// 			w: "b1698117-c6b5-490f-ada2-b003f1dd08e8"
// 		},
// 		{
// 			v: "97357d8d-615d-4069-b022-08841cdee0e8",
// 			w: "fef1a01f-d370-4586-9181-a7386b02b7db"
// 		},
// 		{
// 			v: "b1698117-c6b5-490f-ada2-b003f1dd08e8",
// 			w: "9ef4022f-a46b-4be7-aafd-aaccaa52ecc9"
// 		},
// 		{
// 			v: "97357d8d-615d-4069-b022-08841cdee0e8",
// 			w: "e235bd1d-bec9-4ce7-99e8-88dd35292604"
// 		}
// 	]
// };
